import { render, staticRenderFns } from "./Bimini_steakItem.vue?vue&type=template&id=90e905ee&scoped=true"
import script from "./Bimini_steakItem.vue?vue&type=script&lang=ts"
export * from "./Bimini_steakItem.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_steakItem.vue?vue&type=style&index=0&id=90e905ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e905ee",
  null
  
)

export default component.exports